
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/survey/aep/prescriptions",
      function () {
        return require("private-next-pages/account/survey/aep/prescriptions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/survey/aep/prescriptions"])
      });
    }
  